/* globals MicroModal */

Wee.fn.make('modals', {
	init: function() {
		this.$private.load();
	}
}, {
	load: function() {
		$.assets.load({
			root: $.get('cdnUrl'),
			js: '/assets/js/lib/vendor/micromodal.min.js',
			success: function() {
				var modalVideos = document.querySelectorAll('[data-modal-video]'),
				closeModal = function(iframe) {
					iframe.src = '';
				};

				for (var i = 0; i < modalVideos.length; i++) {
					var link = modalVideos[i].dataset.modalVideo,
							modalId = modalVideos[i].dataset.micromodalTrigger,
							modalEl = document.querySelector('#' + modalId),
							modalVideo = modalEl.querySelector('[data-modal-embed]');

					MicroModal.init({
						onClose: function() {
							closeModal(modalVideo);
						}
					});

					modalVideos[i].addEventListener('click', function() {
						modalVideo.src = link;
						MicroModal.show(modalId);
					});
				}
			}
		});
	}
});
